module.exports = __webpack_public_path__ + "img/teric-chan.bbfdceda.png";